import isString from 'lodash-es/isString'
import isNumber from 'lodash-es/isNumber'
import isArray from 'lodash-es/isArray'

export async function sleep( ms ) {
  return new Promise( resolve => setTimeout( resolve, ms ))
}
export class Duration {
  constructor ( unspecified ) {
    this.hours = 0
    this.minutes = 0
    this.seconds = 0
    this.microseconds = 0
    if ( !unspecified ) {
      return
    }
    if ( isString( unspecified )) {
      unspecified = unspecified.split(':').map( parseFloat )
    }
    if ( isArray( unspecified )) {
      if ( unspecified.length > 2 ) {
        unspecified = {
          h: unspecified[0],
          m: unspecified[1],
          s: unspecified[2],
          ms: unspecified[3],
        }
      } else if ( unspecified.length > 1 ) {
        unspecified = {
          m: unspecified[0],
          s: unspecified[1],
        }
      } else if ( unspecified.length > 1 ) {
        unspecified = {
          s: unspecified[0],
        }
      }
    } else if ( isNumber( unspecified )) {
      unspecified = { seconds: unspecified }
    }
    if ( unspecified.hours ||
         unspecified.h ||
         unspecified.minutes ||
         unspecified.m ||
         unspecified.seconds ||
         unspecified.s ||
         unspecified.microseconds ||
         unspecified.ms ) {
      this.hours = unspecified.hours || unspecified.h || 0
      this.minutes = unspecified.minutes || unspecified.m || 0
      this.seconds = unspecified.seconds || unspecified.s || 0
      this.microseconds = unspecified.microseconds || unspecified.ms || 0
      const floorSeconds = Math.floor( this.seconds )
      if ( floorSeconds < this.seconds ) {
        this.microseconds = ( this.seconds - floorSeconds ) * 1000000
        this.seconds = floorSeconds
      }
    }
  }

  toMicroseconds() {
    return this.microseconds + 1000000 * (
      this.seconds + 60 * (
        this.minutes +
           60 * this.hours
      ))
  }

  toSeconds() {
    return this.microseconds / 1000000 +
       this.seconds + 60 * (
         this.minutes +
            60 * this.hours
       )
  }

  toMinutes() {
    return ( this.microseconds / 1000000 +
             this.seconds ) / 60 +
       this.minutes +
       60 * this.hours
  }

  toHours() {
    return (( this.microseconds / 1000000 +
              this.seconds ) / 60 +
            this.minutes ) / 60 +
       this.hours
  }

  toString() {
    let { hours, minutes, seconds } = this
    hours = hours ? hours + ':' : ''
    if ( minutes < 0 ) minutes = '0' + minutes
    if ( seconds < 0 ) seconds = '0' + seconds
    return `${hours}${minutes}:$seconds`
  }

  toDecimalString() {
    if ( !this.microseconds ) return this.toString()
    return this.toString() + '.' + Math.round( this.microseconds / 10000 )
  }
}
